import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        // Navbar
        NavbarHome: 'Home',
        NavbarProducts: 'Products',
        NavbarProductsPrada: 'Solutions',
        NavbarProductsOpenPlatform: 'Open Platform',
        NavbarProductsEcosystem: 'Ecosystem of Services',
        NavbarProductsAirCar: 'Air.Car',

        NavbarCustomers: 'Customers',
        NavbarCustomersCustomers: 'Customers',

        NavbarAboutUs: 'About Us',
        NavbarAboutUsLocations: 'Location',
        NavbarAboutUsCareers: 'Careers',


        //// Presentation

        // Parallax
        PresentationParallaxTitle: 'AiCAR',
        // PresentationParallaxDescription: 'AiCAR collaborates with HARMAN for the HARMAN Spark',
        PresentationParallaxDescription: 'Connecting to the New Mobility!',
        PresentationParallaxContentText: 'AiCAR',
        PresentationParallaxBottom: 'AiCAR Team.',

        // What We Do
        PresentationSection1Title: 'What We Do',
        PresentationSection1Description: 'AiCAR',
        PresentationSection1ContentText: 'We make your journey easier and more connected: we collaborate to build and define your connected vehicle strategies, helping our customers to benefit from a comprehensive connected car ecosystem, with our award-winning vehicle data platform and services.',

        // CONNECTED CAR PLATFORM
        PresentationSection2Title: 'CONNECTED CAR PLATFORM',
        PresentationSection2Description: 'UNLOCK THE VEHICLE’S DIGITAL POTENTIAL',
        PresentationSection2ContentText: 'Our open platform augments the connected vehicle experience by deploying patented technology via a simple yet powerful user experience. Data filtered through deep analytics, gives the user meaningful insights to improve the driving experience, reduce the cost of motoring and to improve safety, during journeys and beyond.',

        // SERVICES
        PresentationSection3Title: 'SERVICES',
        PresentationSection3Description: 'AN ECOSYSTEM OF SERVICES THAT DRIVERS ACTUALLY WANT',
        PresentationSection3ContentText: 'We have curated the most innovative and relevant vehicle services and integrated them all into one platform. Our ecosystem of services drives the adoption of connected vehicle programs, powering daily engagement and monetisation. It is readily available through our open platform via SDK and APIs, and the white-labelled user app. Partnerships with a number of providers deliver relevant services such as roadside assistance, automated insurance, parking, accident management, and many other services that focus on safety, convenience or saving time and money.',

        // AIR.CAR
        PresentationSection4Title: 'AIR.CAR',
        PresentationSection4Description: 'TECHNOLOGY TO COMBAT POLLUTION',
        PresentationSection4ContentText: 'We are committed to helping the world through technology. With patents for real-time CO2 emissions and an Innovate UK funded project for real-time NOx emissions calculations, AiCAR are at the forefront of creating innovative solutions to crucial industry and global issues in the connected car.',

        // Awarded for our Commitment to Innovation
        PresentationSection5Title: 'Awarded for our Commitment to Innovation',
        PresentationSection5Description: 'AiCAR',
        PresentationSection5ContentText: 'AiCAR',

        // CONTACT INFO
        PresentationSection6Title: 'CONTACT INFO',
        PresentationSection6Description: 'AiCAR',
        PresentationSection6ContentText1: 'Address: [13493] 49, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea',
        PresentationSection6ContentText2: 'Email: info@ai-car.co.kr | Tel: +82-70-7010-1133 | Fax: +82-31-789-0009',



        welcomeMsg: 'Welcome to Your Vue.js App',
        guide: 'For a guide and recipes on how to configure / customize this project,',
        checkout: 'check out the',
        plugins: 'Installed CLI Plugins',
        links: 'Essential Links',
        ecosystem: 'Ecosystem'
    },
    'ko': {
        // Navbar
        NavbarHome: '홈',
        NavbarProducts: '제품',
        NavbarProductsPrada: '솔루션',
        NavbarProductsOpenPlatform: '오픈 플랫폼',
        NavbarProductsEcosystem: '에코시스템',
        NavbarProductsAirCar: 'Air.Car',

        NavbarCustomers: '고객',
        NavbarCustomersCustomers: '고객',

        NavbarAboutUs: 'About Us',
        NavbarAboutUsLocations: '오시는 길',
        NavbarAboutUsCareers: '입사지원',


        //// Presentation

        // Parallax
        PresentationParallaxTitle: 'AiCAR',
        PresentationParallaxDescription: '(주)아이카는 탄탈럼... ',
        PresentationParallaxContentText: 'AiCAR',
        PresentationParallaxBottom: 'AiCAR Team.',

        // What We Do
        PresentationSection1Title: '우리가 하는 일',
        PresentationSection1Description: 'AiCAR',
        PresentationSection1ContentText: '차량과 차량의 운행 정보를 온라인으로 연결시켜 편리하게 ...',

        // CONNECTED CAR PLATFORM
        PresentationSection2Title: '커넥티드 카 플랫폼',
        PresentationSection2Description: '디지털 기술로 차량 운행의 편의성을 극대화...',
        PresentationSection2ContentText: '우리의 오픈 플랫폼 기술로... 커넥티드 카... ',

        // SERVICES
        PresentationSection3Title: '서비스',
        PresentationSection3Description: '운전자를 위한 에코시스템(Eco System)',
        PresentationSection3ContentText: '꼭 필요했던 기능들만 모았습니다... ',

        // AIR.CAR
        PresentationSection4Title: 'AIR.CAR',
        PresentationSection4Description: '초미세먼지와 매연에 대항하는 기술',
        PresentationSection4ContentText: '기술로 세상을 보호할 수 있을까요...',

        // Awarded for our Commitment to Innovation
        PresentationSection5Title: '수상 내역',
        PresentationSection5Description: 'AiCAR',
        PresentationSection5ContentText: 'AiCAR',

        // CONTACT INFO
        PresentationSection6Title: '회사 정보',
        PresentationSection6Description: 'AiCAR',
        PresentationSection6ContentText1: '주소: [13493] 경기 성남시 분당구 대왕판교로644번길 49 코리아벤처타운',
        PresentationSection6ContentText2: 'Email: info@handycar.co.kr | Tel: +82-70-7010-1133 | Fax: +82-31-789-0009',



        welcomeMsg: '안녕하세요',
        guide: 'Para una guía y recetas sobre cómo configurar / personalizar este proyecto,',
        checkout: 'revisar la',
        plugins: 'Plugins de CLI instalados',
        links: 'Enlaces esenciales',
        ecosystem: 'Ecosistema'
    }
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'ko', // set fallback locale
    messages, // set locale messages
});

export default i18n;